module.exports = __webpack_public_path__ + "pc/img/iconRed2.8cea8fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/iconRed2.png
// module id = jQ1j
// module chunks = 3